import { PqrSummary, ProjectDetails, WpsSummary, WizardStep } from '../types'

export const projects: ProjectDetails[] = [
  {
    id: 'proj-004',
    name: 'Red River Gathering Line',
    client: 'Delta Midstream',
    application: 'Gathering Pipeline',
    location: 'Midland, TX',
    status: 'Active',
    pipeSizeRange: '3 pipe size sets',
    targetWpsCount: 6,
    dueDate: '2024-12-20',
    pipeSets: [
      { id: 'pipe-004-1', nominalOd: '10.75', nominalOdUnit: 'in', wallThickness: '0.500', wallThicknessUnit: 'in' },
      { id: 'pipe-004-2', nominalOd: '8.625', nominalOdUnit: 'in', wallThickness: '0.375', wallThicknessUnit: 'in' },
      { id: 'pipe-004-3', nominalOd: '16', nominalOdUnit: 'in', wallThickness: '0.625', wallThicknessUnit: 'in' }
    ]
  },
  {
    id: 'proj-001',
    name: 'North Ridge 36-in Pipeline',
    client: 'IronGate Energy',
    application: 'Transmission Pipeline',
    location: 'Odessa, TX',
    status: 'Active',
    pipeSizeRange: '12 in - 36 in',
    targetWpsCount: 18,
    dueDate: '2024-11-18',
    pipeSets: []
  },
  {
    id: 'proj-002',
    name: 'Bayview LNG Fabrication',
    client: 'Harbor LNG',
    application: 'LNG Fabrication',
    location: 'Port Arthur, TX',
    status: 'Pending',
    pipeSizeRange: '2 in - 10 in',
    targetWpsCount: 9,
    dueDate: '2024-10-05',
    pipeSets: []
  },
  {
    id: 'proj-003',
    name: 'Rockline Compressor Station',
    client: 'Summit Midstream',
    application: 'Compressor Station',
    location: 'Cheyenne, WY',
    status: 'Active',
    pipeSizeRange: '6 in - 24 in',
    targetWpsCount: 12,
    dueDate: '2024-12-02',
    pipeSets: []
  }
]

export const wpsSummaries: WpsSummary[] = [
  {
    id: 'wps-1001',
    number: 'WPS-PL-0012',
    projectId: 'proj-001',
    status: 'Review',
    process: 'GMAW + FCAW',
    baseMaterial: 'API 5L X60 (Group 1)',
    thicknessRange: '8 mm - 25 mm',
    jointType: 'Single V, 60°',
    position: '5G / 6G',
    lastUpdated: '2024-09-05',
    revision: 'B'
  },
  {
    id: 'wps-1002',
    number: 'WPS-PL-0013',
    projectId: 'proj-001',
    status: 'Draft',
    process: 'SMAW',
    baseMaterial: 'API 5L X65 (Group 2)',
    thicknessRange: '12 mm - 32 mm',
    jointType: 'Double V, 70°',
    position: '2G / 5G',
    lastUpdated: '2024-09-02',
    revision: 'A'
  },
  {
    id: 'wps-1003',
    number: 'WPS-PL-0007',
    projectId: 'proj-002',
    status: 'Approved',
    process: 'GTAW + SAW',
    baseMaterial: 'ASTM A106 Gr B',
    thicknessRange: '3 mm - 12 mm',
    jointType: 'Single V, 45°',
    position: '1G / 2G',
    lastUpdated: '2024-08-19',
    revision: 'C'
  },
  {
    id: 'wps-1004',
    number: 'WPS-PL-0020',
    projectId: 'proj-003',
    status: 'Approved',
    process: 'FCAW',
    baseMaterial: 'ASTM A350 LF2',
    thicknessRange: '10 mm - 28 mm',
    jointType: 'Single V, 60°',
    position: '3G / 4G',
    lastUpdated: '2024-09-01',
    revision: 'A'
  }
]

export const pqrSummaries: PqrSummary[] = [
  {
    id: 'pqr-402',
    number: 'PQR-402',
    process: 'GMAW + FCAW',
    baseMaterial: 'API 5L X60',
    thickness: '12 mm',
    qualifiedRange: '6 mm - 25 mm',
    dateQualified: '2024-07-14'
  },
  {
    id: 'pqr-415',
    number: 'PQR-415',
    process: 'SMAW',
    baseMaterial: 'API 5L X65',
    thickness: '16 mm',
    qualifiedRange: '8 mm - 32 mm',
    dateQualified: '2024-08-03'
  },
  {
    id: 'pqr-387',
    number: 'PQR-387',
    process: 'GTAW + SAW',
    baseMaterial: 'ASTM A106 Gr B',
    thickness: '8 mm',
    qualifiedRange: '3 mm - 12 mm',
    dateQualified: '2024-06-22'
  }
]

export const wizardSteps: WizardStep[] = [
  {
    title: 'Win Project',
    description: 'Capture contract scope, pipe sizes, and codes.',
    completed: true
  },
  {
    title: 'WPS Planning',
    description: 'Estimate WPS count based on bevel and pipe sizes.',
    completed: true
  },
  {
    title: 'Floor Sheet',
    description: 'Create weld maps, consumables, and joint design.',
    completed: false
  },
  {
    title: 'PQR',
    description: 'Assign or run procedure qualification records.',
    completed: false
  },
  {
    title: 'WPS',
    description: 'Finalize parameters and generate WPS documents.',
    completed: false
  }
]

export const parameterSuggestions = [
  {
    process: 'GMAW + FCAW',
    baseMaterial: 'API 5L X60',
    recommendation: 'Use 220-260 A, 24-28 V, 0.9-1.3 kJ/mm heat input.',
    confidence: 'High',
    source: '8 historical WPS'
  },
  {
    process: 'SMAW',
    baseMaterial: 'API 5L X65',
    recommendation: 'Preheat 120-150 C, maintain interpass <= 230 C.',
    confidence: 'Medium',
    source: '4 historical WPS'
  },
  {
    process: 'GTAW + SAW',
    baseMaterial: 'ASTM A106 Gr B',
    recommendation: 'Root pass 90-110 A, fill SAW 400-480 A.',
    confidence: 'High',
    source: '6 historical WPS'
  }
]

export const validationFlags = [
  {
    field: 'Heat input',
    issue: 'Exceeds qualified range from PQR-402.',
    severity: 'High',
    action: 'Adjust travel speed or current.'
  },
  {
    field: 'Shielding gas',
    issue: 'CO2 > 25% for GMAW on Group 2 material.',
    severity: 'Medium',
    action: 'Use 80/20 Ar/CO2 or update PQR.'
  },
  {
    field: 'Joint design',
    issue: 'Root gap below minimum for 12 mm wall.',
    severity: 'Low',
    action: 'Increase to 3 mm to avoid lack of fusion.'
  }
]
